module.exports = __webpack_public_path__ + "img/daily-calendar-svgrepo-com.c8fceaa3.svg";